<div *ngIf="!loading ; else app_loading">
  <app-widget-indicators-filters-pivot *ngFor="let pivot of pivots" (sendSelected)="receiveSelect($event)" [filters]="widgetLayers.filter(pivot.uid.value)" [indicators]="widgetLayers.indicators" [pivot]="pivot" [current]="current == pivot.uid.value"></app-widget-indicators-filters-pivot>
</div>
<ng-template #app_loading>
  <app-loading></app-loading>
</ng-template>